/* ============================================================
   Sportkipik — page hub (créateur). Interactions du design.
   Sticky topbar · reveal au scroll · FAQ accordéon (un seul ouvert).
   ============================================================ */
(function () {
  'use strict';

  // Sticky topbar
  var topbar = document.querySelector('.topbar');
  if (topbar) {
    var onScroll = function () { topbar.classList.toggle('show', window.scrollY > window.innerHeight * 0.85); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Reveal au scroll
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (e) { io.observe(e); });
  } else {
    reveals.forEach(function (e) { e.classList.add('in'); });
  }

  // FAQ accordéon — un seul ouvert à la fois
  var items = document.querySelectorAll('.faq__item');
  function setH(item, open) { var a = item.querySelector('.faq__a'); if (!a) return; a.style.maxHeight = open ? a.scrollHeight + 'px' : '0'; }
  items.forEach(function (item) {
    var q = item.querySelector('.faq__q'); if (!q) return;
    setH(item, item.classList.contains('open'));
    q.addEventListener('click', function () {
      var willOpen = !item.classList.contains('open');
      items.forEach(function (o) { o.classList.remove('open'); var oq = o.querySelector('.faq__q'); if (oq) oq.setAttribute('aria-expanded', 'false'); setH(o, false); });
      if (willOpen) { item.classList.add('open'); q.setAttribute('aria-expanded', 'true'); setH(item, true); }
    });
  });
  window.addEventListener('resize', function () { var o = document.querySelector('.faq__item.open'); if (o) setH(o, true); });
})();
